import { Component, Input, OnInit } from "@angular/core";
import { ChartsFieldsGroup } from "../../charts/charts.model";
import { MillisecondDurationPipe } from "../../pipes/millisecond-duration/millisecond-duration.pipe";
import { setFieldIcon } from "../../shared/models/icons.model";

@Component({
  selector: "app-verbatim-chat-attributes",
  templateUrl: "./verbatim-chat-attributes.component.html",
  styleUrls: ["./verbatim-chat-attributes.component.scss"],
  standalone: false,
})
export class VerbatimChatAttributes implements OnInit {
  @Input() chatMsg: any;
  @Input() fieldGroups: ChartsFieldsGroup[];
  chatAttributes = [];
  chatAttributeKeys = [
    "chat_fields",
    "cumulative_effort",
    "emitter_role",
    "original_verbatim",
    "segment",
    "verbatim_name",
  ];
  chatFieldsKeys = [];

  predictionKeys = ["emitter_role", "segment", "cumulative_effort"];
  secondsValueKeys = ["elapsed_time", "msg_duration"];
  CHAT_FIELDS_GROUP = "Chat Transcript Fields";

  setFieldIcon = setFieldIcon;

  constructor(public millisecondsPipe: MillisecondDurationPipe) {}

  hasChatAttributeValue(value: unknown): boolean {
    return (
      value !== null &&
      value !== undefined &&
      (typeof value !== "string" || value.trim().length > 0)
    );
  }

  ngOnInit() {
    if (!this.chatMsg) return;

    this.chatFieldsKeys = Object.keys(this.chatMsg?.chat_fields[0]);
    this.chatAttributes = this.getAllChatAttributes();
  }

  getChatAttribute(key: string, value: any): any {
    switch (key) {
      case "segment":
        const [{ predict }] = value;
        return [{ [key]: [predict] }];
      case "cumulative_effort":
        if (value.length <= 0) return;
        const [{ cumulative_effort_value }] = value;
        return [{ [key]: [cumulative_effort_value] }];
      case "emitter_role":
        if (key) {
          const [{ predict, emitter_agent_alias }] = value;
          if (predict === "Agent" && emitter_agent_alias !== "Agent 1") {
            return [{ [key]: [predict, emitter_agent_alias] }];
          } else {
            return [{ [key]: [predict] }];
          }
        }
      case "chat_fields":
        const allChatFieldsItems = [];
        const chatFieldsItems = value[0];
        for (let key in chatFieldsItems) {
          if (this.secondsValueKeys.includes(key) && chatFieldsItems[key] > 0) {
            value = this.millisecondsPipe.transform(
              Number(chatFieldsItems[key]),
            );
            allChatFieldsItems.push({ [key]: [value] });
          } else if (!this.secondsValueKeys.includes(key)) {
            allChatFieldsItems.push({ [key]: [chatFieldsItems[key]] });
          }
        }
        return allChatFieldsItems;
      case "original_verbatim":
      case "verbatim_name":
        return [{ [key]: [value] }];
    }
  }

  setOrderOfAttributes() {
    const orderedAttributes = new Map();
    for (let key of this.chatAttributeKeys) {
      const value = this.chatMsg[key];
      if (value) orderedAttributes.set(key, value);
    }
    return orderedAttributes;
  }

  getAllChatAttributes() {
    const chatAttributes = [];
    const orderedAtributes = this.setOrderOfAttributes();
    for (let [key, value] of orderedAtributes) {
      const chatAttribute = this.getChatAttribute(key, value);
      if (chatAttribute) chatAttributes.push(...chatAttribute);
    }
    return chatAttributes;
  }
}
